module.exports = __webpack_public_path__ + "img/Loong1.3baab72f.png";